import React from "react";

type SVGProps = React.SVGAttributes<SVGElement> & { color?: string };

const Logo: React.FC<SVGProps & { archColor?: string }> = ({
  color,
  archColor,
  ...props
}) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="400" height="400" rx="200" fill={color || "#FC0A54"} />
    <path
      d="M199.5 122L28 302C28 302 24.1853 295.687 22 291.5C19.8985 287.474 17 281 17 281L199.5 86.5L315.5 206.5L198.5 332L180.5 315L281 206.5L199.5 122Z"
      fill="white"
    />
  </svg>
);

export default Logo;

export const ThemedLogo: React.FC<
  React.SVGAttributes<SVGElement> & { theme: string }
> = ({ theme, ...props }) => (
  <Logo color={`${theme}3D`} archColor={theme} {...props} />
);

export const AppLogo: React.FC<SVGProps> = ({ color, ...props }) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M296 80C309.255 80 320 90.7452 320 104C320 117.255 309.255 128 296 128C282.745 128 272 117.255 272 104C272 90.7452 282.745 80 296 80ZM296 271.999C309.255 271.999 320 282.745 320 295.999C320 309.254 309.255 319.999 296 319.999C282.745 319.999 272 309.254 272 295.999C272 282.745 282.745 271.999 296 271.999ZM320 200C320 186.745 309.255 176 296 176C282.745 176 272 186.745 272 200C272 213.255 282.745 224 296 224C309.255 224 320 213.255 320 200ZM199.999 271.999C213.254 271.999 223.999 282.745 223.999 295.999C223.999 309.254 213.254 319.999 199.999 319.999C186.744 319.999 175.999 309.254 175.999 295.999C175.999 282.745 186.744 271.999 199.999 271.999ZM223.999 104C223.999 90.7452 213.254 80 199.999 80C186.744 80 175.999 90.7452 175.999 104C175.999 117.255 186.744 128 199.999 128C213.254 128 223.999 117.255 223.999 104ZM199.999 176C213.254 176 223.999 186.745 223.999 200C223.999 213.255 213.254 224 199.999 224C186.744 224 175.999 213.255 175.999 200C175.999 186.745 186.744 176 199.999 176ZM127.998 295.999C127.998 282.745 117.253 271.999 103.998 271.999C90.7432 271.999 79.998 282.745 79.998 295.999C79.998 309.254 90.7432 319.999 103.998 319.999C117.253 319.999 127.998 309.254 127.998 295.999ZM103.998 80C117.253 80 127.998 90.7452 127.998 104C127.998 117.255 117.253 128 103.998 128C90.7432 128 79.998 117.255 79.998 104C79.998 90.7452 90.7432 80 103.998 80ZM127.998 200C127.998 186.745 117.253 176 103.998 176C90.7432 176 79.998 186.745 79.998 200C79.998 213.255 90.7432 224 103.998 224C117.253 224 127.998 213.255 127.998 200Z"
      fill="#FC0A54"
    />
  </svg>
);

export const VIPLogo: React.FC<SVGProps> = ({ color, ...props }) => (
  <svg
    viewBox="0 0 400 400"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="400" height="400" rx="200" fill={color || "white"} />
    <path
      d="M199.5 122L28 302C28 302 24.1853 295.687 22 291.5C19.8985 287.474 17 281 17 281L199.5 86.5L315.5 206.5L198.5 332L180.5 315L281 206.5L199.5 122Z"
      fill="black"
    />
  </svg>
);
